import React, { useEffect, useState } from 'react'
import { registerRemoteOnce } from './register-remotes'

/**
 * Registers the given remote on mount, then renders children once registration is done.
 * Used so only the remote for the current route is loaded (on-demand), not all remotes at bootstrap.
 */
function RemoteGate({ remote, children }) {
  const [ready, setReady] = useState(false)

  useEffect(() => {
    registerRemoteOnce(remote).then(() => setReady(true))
  }, [remote])

  if (!ready) {
    return <div />
  }
  return children
}

export default RemoteGate
